import config from 'config';

import { getHashedIndex } from '@lyearn/core/utils/hashCode';

export interface Avatar {
  url: string;
  color: string;
}

const BASE_URL = `${config.cdn_domain}/assets/avatars/`;

export const avatars: Avatar[] = [
  { url: `${BASE_URL}image-1.jpg`, color: '#9BC475' },
  { url: `${BASE_URL}image-2.jpg`, color: '#F4ADE9' },
  { url: `${BASE_URL}image-3.jpg`, color: '#F4ADE9' },
  { url: `${BASE_URL}image-4.jpg`, color: '#137371' },
  { url: `${BASE_URL}image-5.jpg`, color: '#F7461A' },
  { url: `${BASE_URL}image-6.jpg`, color: '#FBD25C' },
  { url: `${BASE_URL}image-7.jpg`, color: '#498496' },
  { url: `${BASE_URL}image-8.jpg`, color: '#B4BAEA' },
  { url: `${BASE_URL}image-9.jpg`, color: '#F44975' },
  { url: `${BASE_URL}image-10.jpg`, color: '#F88372' },
  { url: `${BASE_URL}image-11.jpg`, color: '#2C2B29' },
  { url: `${BASE_URL}image-12.jpg`, color: '#070E2A' },
  { url: `${BASE_URL}image-13.jpg`, color: '#1E291B' },
  { url: `${BASE_URL}image-14.jpg`, color: '#AA717A' },
  { url: `${BASE_URL}image-15.jpg`, color: '#DA8E36' },
  { url: `${BASE_URL}image-16.jpg`, color: '#E28E69' },
  { url: `${BASE_URL}image-17.jpg`, color: '#3BD39A' },
  { url: `${BASE_URL}image-18.jpg`, color: '#8285B2' },
  { url: `${BASE_URL}image-19.jpg`, color: '#FFC1D8' },
  { url: `${BASE_URL}image-20.jpg`, color: '#A9D7D5' },
  { url: `${BASE_URL}image-21.jpg`, color: '#F78B9B' },
  { url: `${BASE_URL}image-22.jpg`, color: '#3948D9' },
  { url: `${BASE_URL}image-23.jpg`, color: '#29323D' },
  { url: `${BASE_URL}image-24.jpg`, color: '#F64561' },
  { url: `${BASE_URL}image-25.jpg`, color: '#FF7852' },
  { url: `${BASE_URL}image-26.jpg`, color: '#EF5B37' },
  { url: `${BASE_URL}image-27.jpg`, color: '#D4883A' },
  { url: `${BASE_URL}image-28.jpg`, color: '#C7BE95' },
  { url: `${BASE_URL}image-29.jpg`, color: '#4E5462' },
  { url: `${BASE_URL}image-30.jpg`, color: '#0A1B2B' },
  { url: `${BASE_URL}image-31.jpg`, color: '#424A5B' },
  { url: `${BASE_URL}image-32.jpg`, color: '#F19CAF' },
  { url: `${BASE_URL}image-33.jpg`, color: '#F5613D' },
  { url: `${BASE_URL}image-34.jpg`, color: '#D74D43' },
  { url: `${BASE_URL}image-35.jpg`, color: '#F2231D' },
  { url: `${BASE_URL}image-36.jpg`, color: '#26BC8C' },
  { url: `${BASE_URL}image-37.jpg`, color: '#A8F352' },
  { url: `${BASE_URL}image-38.jpg`, color: '#B9BE95' },
  { url: `${BASE_URL}image-39.jpg`, color: '#90B798' },
  { url: `${BASE_URL}image-40.jpg`, color: '#CF453A' },
  { url: `${BASE_URL}image-41.jpg`, color: '#ADB6D7' },
  { url: `${BASE_URL}image-42.jpg`, color: '#FFE6C7' },
  { url: `${BASE_URL}image-43.jpg`, color: '#D78DA8' },
  { url: `${BASE_URL}image-44.jpg`, color: '#FBC328' },
  { url: `${BASE_URL}image-45.jpg`, color: '#86EC27' },
  { url: `${BASE_URL}image-46.jpg`, color: '#FE5428' },
  { url: `${BASE_URL}image-47.jpg`, color: '#BE82FE' },
  { url: `${BASE_URL}image-48.jpg`, color: '#BE82FE' },
  { url: `${BASE_URL}image-49.jpg`, color: '#FE8CFE' },
  { url: `${BASE_URL}image-50.jpg`, color: '#FF8242' },
  { url: `${BASE_URL}image-51.jpg`, color: '#7094EA' },
  { url: `${BASE_URL}image-52.jpg`, color: '#FDC228' },
  { url: `${BASE_URL}image-53.jpg`, color: '#75B9A0' },
  { url: `${BASE_URL}image-54.jpg`, color: '#BCC062' },
  { url: `${BASE_URL}image-55.jpg`, color: '#F6B923' },
  { url: `${BASE_URL}image-56.jpg`, color: '#FF6191' },
  { url: `${BASE_URL}image-57.jpg`, color: '#7668F9' },
  { url: `${BASE_URL}image-58.jpg`, color: '#FE750D' },
  { url: `${BASE_URL}image-59.jpg`, color: '#9A45A2' },
  { url: `${BASE_URL}image-60.jpg`, color: '#638AD9' },
  { url: `${BASE_URL}image-61.jpg`, color: '#6890FF' },
  { url: `${BASE_URL}image-62.jpg`, color: '#14845C' },
  { url: `${BASE_URL}image-63.jpg`, color: '#A7AA3F' },
  { url: `${BASE_URL}image-64.jpg`, color: '#5C9052' },
  { url: `${BASE_URL}image-65.jpg`, color: '#7A929C' },
  { url: `${BASE_URL}image-66.jpg`, color: '#82B8A0' },
  { url: `${BASE_URL}image-67.jpg`, color: '#FF9478' },
  { url: `${BASE_URL}image-68.jpg`, color: '#9CA7BD' },
  { url: `${BASE_URL}image-69.jpg`, color: '#3B4C5E' },
  { url: `${BASE_URL}image-70.jpg`, color: '#7A86AE' },
  { url: `${BASE_URL}image-71.jpg`, color: '#FF4C6A' },
  { url: `${BASE_URL}image-72.jpg`, color: '#FF7B6C' },
  { url: `${BASE_URL}image-73.jpg`, color: '#7132A7' },
  { url: `${BASE_URL}image-74.jpg`, color: '#FF5033' },
  { url: `${BASE_URL}image-75.jpg`, color: '#81DAAE' },
  { url: `${BASE_URL}image-76.jpg`, color: '#1379B9' },
  { url: `${BASE_URL}image-77.jpg`, color: '#F76439' },
  { url: `${BASE_URL}image-78.jpg`, color: '#8BDD71' },
  { url: `${BASE_URL}image-79.jpg`, color: '#AA64C6' },
  { url: `${BASE_URL}image-80.jpg`, color: '#F8CE44' },
  { url: `${BASE_URL}image-81.jpg`, color: '#73C5BF' },
  { url: `${BASE_URL}image-82.jpg`, color: '#F38892' },
  { url: `${BASE_URL}image-83.jpg`, color: '#DD3E54' },
  { url: `${BASE_URL}image-84.jpg`, color: '#423428' },
  { url: `${BASE_URL}image-85.jpg`, color: '#AF2A25' },
  { url: `${BASE_URL}image-86.jpg`, color: '#4A6262' },
  { url: `${BASE_URL}image-87.jpg`, color: '#D0A68D' },
  { url: `${BASE_URL}image-88.jpg`, color: '#A5415B' },
  { url: `${BASE_URL}image-89.jpg`, color: '#4D6DC2' },
  { url: `${BASE_URL}image-90.jpg`, color: '#5F4924' },
  { url: `${BASE_URL}image-91.jpg`, color: '#BA5C1F' },
  { url: `${BASE_URL}image-92.jpg`, color: '#4E4B42' },
  { url: `${BASE_URL}image-93.jpg`, color: '#D0892D' },
  { url: `${BASE_URL}image-94.jpg`, color: '#FF6C38' },
  { url: `${BASE_URL}image-95.jpg`, color: '#FF6C38' },
  { url: `${BASE_URL}image-96.jpg`, color: '#4C5B9C' },
  { url: `${BASE_URL}image-97.jpg`, color: '#475021' },
  { url: `${BASE_URL}image-98.jpg`, color: '#1E2D1A' },
  { url: `${BASE_URL}image-99.jpg`, color: '#7292C5' },
  { url: `${BASE_URL}image-100.jpg`, color: '#E8443A' },
  { url: `${BASE_URL}image-101.jpg`, color: '#360F5D' },
  { url: `${BASE_URL}image-102.jpg`, color: '#30AC58' },
  { url: `${BASE_URL}image-103.jpg`, color: '#38CAA5' },
  { url: `${BASE_URL}image-104.jpg`, color: '#97ADC2' },
  { url: `${BASE_URL}image-105.jpg`, color: '#2C4353' },
  { url: `${BASE_URL}image-106.jpg`, color: '#62151F' },
  { url: `${BASE_URL}image-107.jpg`, color: '#FFB039' },
  { url: `${BASE_URL}image-108.jpg`, color: '#D03732' },
  { url: `${BASE_URL}image-109.jpg`, color: '#C2297C' },
  { url: `${BASE_URL}image-110.jpg`, color: '#1D1B17' },
  { url: `${BASE_URL}image-111.jpg`, color: '#4C4CD0' },
  { url: `${BASE_URL}image-112.jpg`, color: '#634D42' },
  { url: `${BASE_URL}image-113.jpg`, color: '#C7AB7B' },
  { url: `${BASE_URL}image-114.jpg`, color: '#1F9D1F' },
  { url: `${BASE_URL}image-115.jpg`, color: '#F56435' },
  { url: `${BASE_URL}image-116.jpg`, color: '#FF679F' },
  { url: `${BASE_URL}image-117.jpg`, color: '#8219CE' },
  { url: `${BASE_URL}image-118.jpg`, color: '#EA323A' },
  { url: `${BASE_URL}image-119.jpg`, color: '#A8A38D' },
  { url: `${BASE_URL}image-120.jpg`, color: '#FFCD0E' },
];

export const getRandomAvatar = () => {
  const randomNumber = Math.floor(Math.random() * avatars.length);
  return avatars[randomNumber].url;
};

export const getHashedAvatar = (name: string): string => {
  const index = getHashedIndex(name, avatars.length);
  return avatars[index].url;
};
